<ng-container *ngIf="checkedGoDaddy; then WebsitePro; else None"></ng-container>
<ng-container *ngIf="checkedWebsitePro; then GoDaddy; else None"></ng-container>
<ng-template #None style="display: none"></ng-template>

<ng-template #GoDaddy>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <span>{{ 'PRODUCT_ACTIVATION.DOMAIN_QUESTION' | translate }}</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <span>{{ 'PRODUCT_ACTIVATION.DOMAIN_VALUE' | translate }}</span>
      <ng-container *ngIf="goDaddy$ | async as goDaddy">
        <div class="item-container">
          <div class="item-sub-container">
            <div class="item-title">
              <va-icon [diameter]="32" [iconUrl]="goDaddy.icon_url" [iconName]="goDaddy.name"></va-icon>
              <span class="item-name">{{ goDaddy.name }}</span>
            </div>
            <app-activation-table-pricing
              [pricing]="goDaddyPricing"
              [billingId]="goDaddy?.billing_id"
            ></app-activation-table-pricing>
          </div>
        </div>
      </ng-container>
    </mat-card-content>
    <mat-card-actions>
      <button (click)="addProduct(appNames.WEBSITE)" color="primary" mat-flat-button>
        <span>
          {{ 'PRODUCT_ACTIVATION.DOMAIN_CONFIRMATION' | translate }}
        </span>
      </button>
      <button (click)="removeCheckedProducts()" mat-stroked-button>
        {{ 'PRODUCT_ACTIVATION.NO_THANK_YOU' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</ng-template>

<ng-template #WebsitePro>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <span>{{ 'PRODUCT_ACTIVATION.WEBSITE_QUESTION' | translate }}</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <span>{{ 'PRODUCT_ACTIVATION.WEBSITE_VALUE' | translate }}</span>
      <ng-container *ngIf="websitePro$ | async as websitePro">
        <div class="item-container">
          <div class="item-sub-container">
            <div class="item-title">
              <va-icon [diameter]="32" [iconUrl]="websitePro.icon_url" [iconName]="websitePro.name"></va-icon>
              <span class="item-name">{{ websitePro.name }}</span>
            </div>
            <app-activation-table-pricing
              [pricing]="websiteProPricing"
              [billingId]="websitePro?.billing_id"
            ></app-activation-table-pricing>
          </div>
        </div>
      </ng-container>
    </mat-card-content>
    <mat-card-actions>
      <button (click)="removeCheckedProducts()" mat-stroked-button>
        {{ 'PRODUCT_ACTIVATION.NO_THANK_YOU' | translate }}
      </button>
      <button (click)="addProduct(appNames.GO_DADDY)" color="primary" mat-flat-button>
        <span>
          {{ 'PRODUCT_ACTIVATION.WEBSITE_CONFIRMATION' | translate }}
        </span>
      </button>
    </mat-card-actions>
  </mat-card>
</ng-template>
